import { z } from 'zod/mini'

import { gtmMetadataShape } from './gtm-metadata'
import { itemSchema } from './item'
import { nonEmptyString } from './non-empty-string'

export const selectItemSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('select_item'),
  ecommerce: z.strictObject({
    currency: nonEmptyString(),
    item_list_id: nonEmptyString(),
    item_list_name: nonEmptyString(),
    items: z
      .array(
        z.strictObject({
          ...itemSchema.shape,
          item_list_id: nonEmptyString(),
          item_list_name: nonEmptyString(),
        }),
      )
      .check(z.minLength(1), z.maxLength(1)),
  }),
})
